export interface InsidePage {
  id: string
  src: string
  alt: string
  caption: string
}

export const insidePages: InsidePage[] = [
  {
    id: 'entry-security',
    src: 'https://cdn.magicpatterns.com/uploads/4uBjsM464DjTCH2jzimLtm/Captura-de-pantalla-2026-09-17-a-la_s_-1.37.21_p._m..webp',
    alt: 'Complete Project — Smart Entry & Security Layer, with labeled devices, hub architecture and project objectives',
    caption: 'Complete Project — Smart Entry & Security Layer',
  },
  {
    id: 'whole-home',
    src: 'https://cdn.magicpatterns.com/uploads/kyChgvB5pHUCTZajKdboyp/Captura-de-pantalla-2026-09-17-a-la_s_-1.36.48_p._m..webp',
    alt: 'Complete Project — Whole-Home Smart System, room-by-room device map connected to Home Assistant',
    caption: 'Complete Project — Whole-Home Smart System',
  },
  {
    id: 'scene-architecture',
    src: 'https://cdn.magicpatterns.com/uploads/vGJ8g2BCCRf8YpfYienmPj/Captura-de-pantalla-2026-09-17-a-la_s_-1.36.28_p._m..webp',
    alt: 'Smart Living Room — Scene Architecture, comparing Everyday, Entertain, Movie and Away scenes',
    caption: 'Smart Living Room — Scene Architecture',
  },
  {
    id: 'security-layer',
    src: 'https://cdn.magicpatterns.com/uploads/ag7kUABbBUZaQnFHDjA853/Captura-de-pantalla-2026-09-17-a-la_s_-1.35.33_p._m..webp',
    alt: 'Building a Residential Security Layer, floor plan with detection, verification, response and notification zones',
    caption: 'Building a Residential Security Layer',
  },
  {
    id: 'entry-lighting',
    src: 'https://cdn.magicpatterns.com/uploads/2ukE3X6vriReHhgsLR3HiR/Captura-de-pantalla-2026-09-17-a-la_s_-1.34.49_p._m..webp',
    alt: 'Project Blueprint — Automated Entry Lighting, sensor placement plan and four-stage automation logic',
    caption: 'Project Blueprint — Automated Entry Lighting',
  },
]
